import { GetBodyworkerProtocolListsResponse } from "@/app/api/bodyworker-protocol-lists/route";
import { createInvalidateQuery, createQueryHook } from "@/lib/queries";
import { getBodyworkerProtocolListsRequestSchema } from "@/lib/schemas/bodyworker-protocol-lists";

const BODYWORKER_PROTOCOL_LISTS_ENDPOINT = "/api/bodyworker-protocol-lists";

export const invalidateBodyworkerProtocolListsQuery = createInvalidateQuery(
  BODYWORKER_PROTOCOL_LISTS_ENDPOINT,
);

export const useBodyworkerProtocolListsQuery =
  createQueryHook<GetBodyworkerProtocolListsResponse>(
    BODYWORKER_PROTOCOL_LISTS_ENDPOINT,
    getBodyworkerProtocolListsRequestSchema,
  );
